import { computed } from 'vue';

export function useKbd(keys) {
  const keySymbols = {
    $mod: 'Ctrl',
    shift: '⇧',
    alt: 'Alt',
    ctrl: 'Ctrl',
    cmd: 'Ctrl',
    option: 'Alt',
    enter: '↵',
    tab: '⇥',
    esc: '⎋',
  };

  return computed(() => {
    return keys
      .map(key => keySymbols[key.toLowerCase()] || key)
      .join(' ')
      .toUpperCase();
  });
}

export function getModifierKey() {
  return 'Ctrl';
}
